<cb-dialog>
    <form class="flex-col flex" #eventsForm="ngForm">
        <h1 class="mat-headline-6">{{ mappedItem.id > 0 ? 'Edit' : 'New' }} Event</h1>
        <cb-input
            type="text"
            name="code"
            label="Event Code"
            [pattern]="eventCodePattern"
            [minlength]="3"
            [required]="true"
            [(ngModel)]="mappedItem.code"
            #codeModel="ngModel"
        ></cb-input>
        @if (codeModel.invalid && (codeModel.dirty || codeModel.touched)) {
            <div class="cb-field-error">
                @if (codeModel.hasError('minlength')) {
                    <div>
                        At least 3 characters
                    </div>
                }

                @if (codeModel.hasError('pattern') || codeModel.hasError('eventCodeAlphanumericOnly')) {
                    <div>
                        Letters and numbers only - no spaces or special characters
                    </div>
                }
            </div>
        }

        <cb-input
            type="text"
            name="name"
            label="Event Name"
            [required]="true"
            [(ngModel)]="mappedItem.label"
        ></cb-input>
        <cb-checkbox
            name="isActive"
            label="Is Active"
            [(ngModel)]="mappedItem.isActive"
        ></cb-checkbox>
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            (cbClick)="save()"
            [clickLimit]="1"
            [disabled]="!eventsForm.dirty || !eventsForm.valid"
        >
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
